import { render } from "./TransitionHeight.vue?vue&type=template&id=5ac2ca06"
import script from "./TransitionHeight.vue?vue&type=script&lang=js"
export * from "./TransitionHeight.vue?vue&type=script&lang=js"

import "./TransitionHeight.vue?vue&type=style&index=0&id=5ac2ca06&lang=scss"

import exportComponent from "/Users/patricksantner/projects/alpbach-ticketshop-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__